import type { Config } from './types';

// Baked into the snippet at build time. Used when the live config fetch
// fails (mvp_b_plan.md §5.3 fail-open) or before the fetch lands.
export const FALLBACK_CONFIG: Config = {
  categories: [
    {
      id: 'strictly_necessary',
      label: 'Strictly necessary',
      description: 'Required for the site to work. Always on.',
      required: true,
    },
    {
      id: 'functional',
      label: 'Functional',
      description: 'Remembers preferences such as language.',
    },
    {
      id: 'analytics',
      label: 'Analytics',
      description: 'Helps us understand how visitors use the site.',
    },
    {
      id: 'marketing',
      label: 'Marketing',
      description: 'Used to show ads relevant to you on this and other sites.',
    },
  ],
  copy: {
    title: 'Cookies & privacy',
    body: "We use cookies to make this site work and to understand how it's used. You can accept all, reject all, or pick what to allow.",
    acceptAll: 'Accept all',
    rejectAll: 'Reject all',
    managePrefs: 'Manage preferences',
    save: 'Save preferences',
    footerLink: 'Cookie preferences',
    poweredBy: 'Powered by cookies.ie',
  },
  theme: {
    primary: '#111111',
    text: '#1a1a1a',
    background: '#ffffff',
    border: '#e5e5e5',
    position: 'bottom',
  },
  defaults: {
    showBannerAfter: 'interactive',
    honourGpc: true,
  },
  policyRevision: 1,
  language: 'en',
};
